import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './Noti.styles';
import { Link } from 'react-router-dom';

interface NotiProps {
  img: string;
  msg: string;
}

export const Noti: React.FC<NotiProps> = ({ img, msg }) => {
  const { t } = useTranslation();

  return (
    <S.Wrapper>
      <S.Image preview={false} src={img} />
      <S.ContentWrapper>
        <S.Title>{'안내'}</S.Title>
        <S.Text>{msg}</S.Text>
        {/*TODO make common component */}
        <Link to="/" className="ant-btn ant-btn-link">
          {t('error404.comeBack')}
        </Link>
      </S.ContentWrapper>
    </S.Wrapper>
  );
};
